import axios from "axios";
import { urls } from "../../utils/AppManager";
import { getAuthHeaders, getImportAuthHeaders } from "../../utils/headers";

export const getManageLeadsList = async (
  payload,
  query,
  fromDate,
  toDate,
  userEmail,
  userid,
  advSearch,
  role,
  sortcolumn,
  sortorder,
  dateFilterOn,
) => {
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.ManageLeadsList}?pageNumber= ${payload.currentPage}&pageSize=${
      payload.leadsRecords
    }&leadStage=${payload.leadStages}&leadSource=${
      payload.leadSources
    }&leadOwner=${payload.leadOwners}&searchQuery=${encodeURIComponent(
      query,
    )}&fromDate=${fromDate}&toDate=${toDate}&userEmail=${userEmail}&userid=${userid}&advSearch=${advSearch}&role=${role}&sortcolumn=${sortcolumn}&sortorder=${sortorder}&ekycStage=${
      payload.ekycStages
    }&sourceMedium=${payload.sourceMedium}&dateFilterOn=${dateFilterOn}`;
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error, "error");
    });
  return res;
};

export const getManageLeadsListV2 = async (
  payload,
  query,
  fromDate,
  toDate,
  userEmail,
  userid,
  advSearch,
  role,
  sortcolumn,
  sortorder,
  dateFilterOn,
) => {
  const params = new URLSearchParams({
    pageNumber: payload.currentPage,
    pageSize: payload.leadsRecords,
    leadStage: payload.leadStages,
    leadSource: payload.leadSources,
    leadOwner: payload.leadOwners,
    searchQuery: query,
    fromDate: fromDate,
    toDate: toDate,
    userEmail: userEmail,
    userid: userid,
    role: role,
    sortcolumn: sortcolumn,
    sortorder: sortorder,
    ekycStage: payload.ekycStages,
    sourceMedium: payload.sourceMedium,
    dateFilterOn: dateFilterOn,
  });

  const url = `${process.env.REACT_APP_API_BASE_URL}${
    urls.ManageLeadsListV2
  }?${params.toString()}`;

  const headers = {
    ...getAuthHeaders(),
    "Content-Type": "application/json",
  };

  try {
    const response = await axios.post(url, { advSearch }, { headers });
    return response.data;
  } catch (error) {
    console.error("Error fetching manage leads list:", error);
    throw error;
  }
};

export const getLeadStages = async () => {
  const url = process.env.REACT_APP_API_BASE_URL + urls.leadstage;
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error, "error");
    });
  return res;
};

export const getLeadSources = async () => {
  const url = process.env.REACT_APP_API_BASE_URL + urls.leadsource;
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error, "error");
    });
  return res;
};

export const getLeadOwner = async () => {
  const url = process.env.REACT_APP_API_BASE_URL + urls.leadowner;
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error, "error");
    });
  return res;
};

export const getEkycStages = async () => {
  const url = process.env.REACT_APP_API_BASE_URL + urls.leadEkycStages;
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error, "error");
    });
  return res;
};
export const getSourceMedium = async () => {
  const url = process.env.REACT_APP_API_BASE_URL + urls.leadSourceMedium;
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error, "error");
    });
  return res;
};

export const getLeadAudit = async (value, page, itemscount) => {
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.audit}?leadsid=${value}&pageNumber=${page}&pagesize=${itemscount}`;
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error, "error");
    });
  return res;
};

export const getLeadHistory = async (value, page, itemscount) => {
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.leadHistory}?leadsid=${value}&pageNumber=${page}&pagesize=${itemscount}`;
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error, "error");
    });
  return res;
};

export const getLeadDetails = async (leadsId, userRole) => {
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.leadDetails}?leadsid=${leadsId}&userRole=${userRole}`;
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error, "error");
    });
  return res;
};

export const addLead = async (payload, accessKey, secretKey) => {
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.addLead}?accesskey=${accessKey}&secretkey=${secretKey}`;
  const headers = getAuthHeaders();
  const res = await axios
    .post(url, payload, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error, "error");
    });
  return res;
};

export const callLead = async (payload, callType, userId) => {
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.callLead}?callType=${callType}&userId=${userId}`;
  const headers = getAuthHeaders();
  const res = await axios
    .post(url, payload, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error, "error");
    });
  return res;
};

export const clickToCall = async (payload, callType) => {
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.clickToCall}?callType=${callType}`;
  const headers = getAuthHeaders();
  const res = await axios
    .post(url, payload, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error, "error");
    });
  return res;
};

export const leadEntityDetails = async (roleId, permission, type) => {
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.entityDetails}?role=${roleId}&permission=${permission}&type=${type}`;
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error, "error");
    });
  return res;
};

export const importLead = async (
  file,
  userEmail,
  ignoreFlag,
  overwriteFlag,
  fieldMappings,
) => {
  const url = process.env.REACT_APP_API_BASE_URL + urls.importLead;
  const formData = new FormData();
  formData.append("file", file); // 'file' is the field name expected by the server
  formData.append("email", userEmail);
  formData.append("ignoreLead", ignoreFlag);
  formData.append("overwriteLead", overwriteFlag);
  formData.append("fieldMappings", JSON.stringify(fieldMappings));
  const headers = getImportAuthHeaders();
  const res = await axios
    .post(url, formData, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error, "error");
    });
  return res;
};

// Operation-aware import. The backend takes the importing user from the token
// and validates operation/source/fieldMappings/accesskey/secretkey before
// storing the file, so a rejected request comes back as a 4xx with `error.message`.
export const importLeadByOperation = async (
  file,
  operation,
  source,
  fieldMappings,
  accessKey,
  secretKey,
) => {
  const url = process.env.REACT_APP_API_BASE_URL + urls.importLeadByOperation;
  const formData = new FormData();
  formData.append("file", file);
  formData.append("operation", operation);
  formData.append("source", source);
  formData.append("fieldMappings", JSON.stringify(fieldMappings));
  // The logged-in user's lmswrapper keys; sent in the body, not the URL, so they
  // stay out of access logs.
  formData.append("accesskey", accessKey ?? "");
  formData.append("secretkey", secretKey ?? "");
  const headers = getImportAuthHeaders();
  try {
    const response = await axios.post(url, formData, { headers });
    return {
      success: response.data?.success === true,
      message: response.data?.message,
    };
  } catch (error) {
    console.error(error, "error");
    return {
      success: false,
      message:
        error.response?.data?.error?.message ||
        "Something went wrong. Please try again.",
    };
  }
};

export const exportLead = async (
  value,
  schemaname,
  userEmail,
  roleId,
  filtersData,
) => {
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.exportlead}?relatedleadsid=${value}&fieldsName=${schemaname}&userEmail=${userEmail}&roleId=${roleId}&leadStage=${filtersData?.leadStage}&leadSource=${filtersData?.leadSource}&leadOwner=${filtersData?.leadOwner}&fromDate=${filtersData?.fromDate}&toDate=${filtersData?.toDate}&searchQuery=${filtersData?.searchQuery}&advSearch=${filtersData?.advSearch}&ekycStage=${filtersData?.ekycStage}&sourceMedium=${filtersData?.sourceMedium}`;
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error, "error");
    });
  return res;
};

export const exportLeadWrapper = async (
  value,
  schemaname,
  userEmail,
  roleId,
  filtersData,
  role,
) => {
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.exportLeadWrapper}?relatedleadsid=${value}&fieldsName=${schemaname}&userEmail=${userEmail}&roleId=${roleId}&leadStage=${filtersData?.leadStage}&leadSource=${filtersData?.leadSource}&leadOwner=${filtersData?.leadOwner}&fromDate=${filtersData?.fromDate}&toDate=${filtersData?.toDate}&searchQuery=${filtersData?.searchQuery}&advSearch=${filtersData?.advSearch}&ekycStage=${filtersData?.ekycStage}&sourceMedium=${filtersData?.sourceMedium}&role=${role}&datefilteron=${filtersData.dateFilterOn}`;
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error, "error");
    });
  return res;
};

export const leadSectionDetails = async (roleId, permission, type) => {
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.sectionDetails}?role=${roleId}&permission=${permission}&page=${type}`;
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error, "error");
    });
  return res;
};

export const leadSectionDetailsByRole = async (roleId, permission, page) => {
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.leadPermissionSection}?role=${roleId}&permission=${permission}&page=${page}`;
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error, "error");
    });
  return res;
};

export const editLead = async (
  payload,
  leadsIDs,
  notesEdit,
  userEmail,
  accessKey,
  secretKey,
) => {
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.editLead}?leadIdData=${leadsIDs}&notes=${notesEdit}&emailId=${userEmail}&accesskey=${accessKey}&secretkey=${secretKey}`;
  const headers = getAuthHeaders();
  const res = await axios
    .post(url, payload, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error, "error");
    });
  return res;
};

export const editLeadBulk = async (payload, accessKey, secretKey) => {
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.editLeadBulk}?accesskey=${accessKey}&secretkey=${secretKey}`;
  const headers = getAuthHeaders();
  const res = await axios
    .post(url, payload, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error, "error");
    });
  return res;
};

export const deleteLead = async (payload, accessKey, secretKey) => {
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.deleteLead}?accesskey=${accessKey}&secretkey=${secretKey}`;
  const headers = getAuthHeaders();
  const res = await axios
    .post(url, payload, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error, "error");
    });
  return res;
};

export const getLeadNote = async (value, page, itemscount) => {
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.leadNoteDetail}?leadsid=${value}&pageNumber=${page}&pagesize=${itemscount}`;
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error, "error");
    });
  return res;
};

export const leadEntityConditionDetails = async () => {
  const url = process.env.REACT_APP_API_BASE_URL + urls.leadEntityCondition;
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error, "error");
    });
  return res;
};

export const getCallDispositionList = async () => {
  const url = process.env.REACT_APP_API_BASE_URL + urls.callDisosition;
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error, "error");
    });
  return res;
};

export const getCallSubDispositionList = async () => {
  const url = process.env.REACT_APP_API_BASE_URL + urls.callsubDisposition;
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error, "error");
    });
  return res;
};

const normalizeQueryParamValue = (value) => {
  if (value === undefined || value === null) return "";
  return value;
};

const normalizeAdvSearch = (advSearch) => {
  if (Array.isArray(advSearch)) return advSearch;
  if (typeof advSearch === "string") {
    try {
      const parsed = JSON.parse(advSearch);
      return Array.isArray(parsed) ? parsed : advSearch;
    } catch {
      return advSearch;
    }
  }
  return advSearch;
};

export const getSmartTabsLeadsV2 = async (
  smartViewType,
  payload,
  query,
  fromDate,
  toDate,
  userEmail,
  userid,
  advSearch,
  role,
  sortcolumn,
  sortorder,
  dateFilterOn,
) => {
  const params = new URLSearchParams({
    pageNumber: normalizeQueryParamValue(payload?.currentPage),
    pageSize: normalizeQueryParamValue(payload?.leadsRecords),
    leadStage: normalizeQueryParamValue(payload?.leadStages),
    leadSource: normalizeQueryParamValue(payload?.leadSources),
    leadOwner: normalizeQueryParamValue(payload?.leadOwners),
    searchQuery: normalizeQueryParamValue(query),
    userEmail: normalizeQueryParamValue(userEmail),
    userid: normalizeQueryParamValue(userid),
    role: normalizeQueryParamValue(role),
    sortcolumn: normalizeQueryParamValue(sortcolumn),
    sortorder: normalizeQueryParamValue(sortorder),
    ekycStage: normalizeQueryParamValue(payload?.ekycStages),
    sourceMedium: normalizeQueryParamValue(payload?.sourceMedium),
    dateFilterOn: normalizeQueryParamValue(dateFilterOn),
    fromDate: normalizeQueryParamValue(fromDate),
    toDate: normalizeQueryParamValue(toDate),
  });

  const url = `${process.env.REACT_APP_API_BASE_URL}${urls.smartTabsLeadsV2}/${smartViewType}?${params.toString()}`;

  const headers = {
    ...getAuthHeaders(),
    "Content-Type": "application/json",
  };

  try {
    const response = await axios.post(
      url,
      { advSearch: normalizeAdvSearch(advSearch) },
      { headers },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching smart tabs leads v2:", error);
    throw error;
  }
};

export const getLeadLovValues = async (displayname) => {
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.leadLovDropDown}?displayname=${displayname}`;
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error, "error");
    });
  return res;
};

export const getAgentReferralLeadsList = async (
  payload,
  query,
  fromDate,
  toDate,
  userEmail,
  userid,
  advSearch,
  role,
  sortcolumn,
  sortorder,
  dateFilterOn,
) => {
  const params = new URLSearchParams({
    pageNumber: payload.currentPage,
    pageSize: payload.leadsRecords,
    leadStage: payload.leadStages,
    leadSource: payload.leadSources,
    leadOwner: payload.leadOwners,
    searchQuery: query,
    fromDate: fromDate,
    toDate: toDate,
    userEmail: userEmail,
    userid: userid,
    role: role,
    sortcolumn: sortcolumn,
    sortorder: sortorder,
    ekycStage: payload.ekycStages,
    sourceMedium: payload.sourceMedium,
    dateFilterOn: dateFilterOn,
  });
  const url = `${process.env.REACT_APP_API_BASE_URL}${urls.smartViewAgentReferralLead}?${params.toString()}`;

  const headers = {
    ...getAuthHeaders(),
    "Content-Type": "application/json",
  };

  try {
    const response = await axios.post(url, { advSearch }, { headers });
    return response.data;
  } catch (error) {
    console.error("Error fetching manage leads list:", error);
    throw error;
  }
};

export const getUnAttemptedLeadsList = async (
  payload,
  query,
  fromDate,
  toDate,
  userEmail,
  userid,
  advSearch,
  role,
  sortcolumn,
  sortorder,
  dateFilterOn,
) => {
  const params = new URLSearchParams({
    pageNumber: payload.currentPage,
    pageSize: payload.leadsRecords,
    leadStage: payload.leadStages,
    leadSource: payload.leadSources,
    leadOwner: payload.leadOwners,
    searchQuery: query,
    fromDate: fromDate,
    toDate: toDate,
    userEmail: userEmail,
    userid: userid,
    role: role,
    sortcolumn: sortcolumn,
    sortorder: sortorder,
    ekycStage: payload.ekycStages,
    sourceMedium: payload.sourceMedium,
    dateFilterOn: dateFilterOn,
  });
  const url = `${process.env.REACT_APP_API_BASE_URL}${
    urls.smartViewUnAttemptedLead
  }?${params.toString()}`;

  const headers = {
    ...getAuthHeaders(),
    "Content-Type": "application/json",
  };

  try {
    const response = await axios.post(url, { advSearch }, { headers });
    return response.data;
  } catch (error) {
    console.error("Error fetching manage leads list:", error);
    throw error;
  }
};

export const getMarginNotAddedLeadsList = async (
  payload,
  query,
  fromDate,
  toDate,
  userEmail,
  userid,
  advSearch,
  role,
  sortcolumn,
  sortorder,
  dateFilterOn,
) => {
  const params = new URLSearchParams({
    pageNumber: payload.currentPage,
    pageSize: payload.leadsRecords,
    leadStage: payload.leadStages,
    leadSource: payload.leadSources,
    leadOwner: payload.leadOwners,
    searchQuery: query,
    fromDate: fromDate,
    toDate: toDate,
    userEmail: userEmail,
    userid: userid,
    role: role,
    sortcolumn: sortcolumn,
    sortorder: sortorder,
    ekycStage: payload.ekycStages,
    sourceMedium: payload.sourceMedium,
    dateFilterOn: dateFilterOn,
  });
  const url = `${process.env.REACT_APP_API_BASE_URL}${urls.smartViewMarginNotAddedLead}?${params.toString()}`;

  const headers = {
    ...getAuthHeaders(),
    "Content-Type": "application/json",
  };

  try {
    const response = await axios.post(url, { advSearch }, { headers });
    return response.data;
  } catch (error) {
    console.error("Error fetching manage leads list:", error);
    throw error;
  }
};

export const getFnONotActivatedLeadsList = async (
  payload,
  query,
  fromDate,
  toDate,
  userEmail,
  userid,
  advSearch,
  role,
  sortcolumn,
  sortorder,
  dateFilterOn,
) => {
  const params = new URLSearchParams({
    pageNumber: payload.currentPage,
    pageSize: payload.leadsRecords,
    leadStage: payload.leadStages,
    leadSource: payload.leadSources,
    leadOwner: payload.leadOwners,
    searchQuery: query,
    fromDate: fromDate,
    toDate: toDate,
    userEmail: userEmail,
    userid: userid,
    role: role,
    sortcolumn: sortcolumn,
    sortorder: sortorder,
    ekycStage: payload.ekycStages,
    sourceMedium: payload.sourceMedium,
    dateFilterOn: dateFilterOn,
  });
  const url = `${process.env.REACT_APP_API_BASE_URL}${urls.smartViewFnONotActivatedLead}?${params.toString()}`;

  const headers = {
    ...getAuthHeaders(),
    "Content-Type": "application/json",
  };

  try {
    const response = await axios.post(url, { advSearch }, { headers });
    return response.data;
  } catch (error) {
    console.error("Error fetching manage leads list:", error);
    throw error;
  }
};

export const getTodayCallBackLeadsList = async (
  payload,
  query,
  fromDate,
  toDate,
  userEmail,
  userid,
  advSearch,
  role,
  sortcolumn,
  sortorder,
  dateFilterOn,
) => {
  let url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.smartViewTodayCallBackLead}?pageNumber= ${
      payload.currentPage
    }&pageSize=${payload.leadsRecords}&leadStage=${
      payload.leadStages
    }&leadSource=${payload.leadSources}&leadOwner=${
      payload.leadOwners
    }&searchQuery=${encodeURIComponent(
      query,
    )}&fromDate=${fromDate}&toDate=${toDate}&userEmail=${userEmail}&userid=${userid}&role=${role}&sortcolumn=${sortcolumn}&sortorder=${sortorder}&ekycStage=${
      payload.ekycStages
    }&sourceMedium=${
      payload.sourceMedium
    }&advSearch=${advSearch}&dateFilterOn=${dateFilterOn}`;
  const headers = getAuthHeaders();
  let res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error, "error");
    });
  return res;
};

export const getEKYCModifiedLeadsList = async (
  payload,
  query,
  fromDate,
  toDate,
  userEmail,
  userid,
  advSearch,
  role,
  sortcolumn,
  sortorder,
  dateFilterOn,
) => {
  const params = new URLSearchParams({
    pageNumber: payload.currentPage,
    pageSize: payload.leadsRecords,
    leadStage: payload.leadStages,
    leadSource: payload.leadSources,
    leadOwner: payload.leadOwners,
    searchQuery: query,
    fromDate: fromDate,
    toDate: toDate,
    userEmail: userEmail,
    userid: userid,
    role: role,
    sortcolumn: sortcolumn,
    sortorder: sortorder,
    ekycStage: payload.ekycStages,
    sourceMedium: payload.sourceMedium,
    dateFilterOn: dateFilterOn,
  });

  const url = `${process.env.REACT_APP_API_BASE_URL}${
    urls.getEkycModifiedLeads
  }?${params.toString()}`;

  const headers = {
    ...getAuthHeaders(),
    "Content-Type": "application/json",
  };

  try {
    const response = await axios.post(url, { advSearch }, { headers });
    return response.data;
  } catch (error) {
    console.error("Error fetching manage leads list:", error);
    throw error;
  }
};

export const getEsignNALeadsList = async (
  payload,
  query,
  fromDate,
  toDate,
  userEmail,
  userid,
  advSearch,
  role,
  sortcolumn,
  sortorder,
  dateFilterOn,
) => {
  let url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.getesignnaleads}?pageNumber= ${payload.currentPage}&pageSize=${
      payload.leadsRecords
    }&leadStage=${payload.leadStages}&leadSource=${
      payload.leadSources
    }&leadOwner=${payload.leadOwners}&searchQuery=${encodeURIComponent(
      query,
    )}&fromDate=${fromDate}&toDate=${toDate}&userEmail=${userEmail}&userid=${userid}&role=${role}&sortcolumn=${sortcolumn}&sortorder=${sortorder}&ekycStage=${
      payload.ekycStages
    }&sourceMedium=${
      payload.sourceMedium
    }&advSearch=${advSearch}&dateFilterOn=${dateFilterOn}`;
  const headers = getAuthHeaders();
  let res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error, "error");
    });

  return res;
};

export const exportSmartViewsLead = async (
  value,
  schemaname,
  userEmail,
  roleId,
  filtersData,
) => {
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.smartViewsExport}?relatedleadsid=${value}&fieldsName=${schemaname}&userEmail=${userEmail}&roleId=${roleId}&leadStage=${filtersData?.leadStage}&leadSource=${filtersData?.leadSource}&leadOwner=${filtersData?.leadOwner}&fromDate=${filtersData?.fromDate}&toDate=${filtersData?.toDate}&tab=${filtersData?.tab}&ekycStage=${filtersData?.ekycStage}&sourceMedium=${filtersData?.sourceMedium}`;
  console.error(url, value);
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error, "error");
    });
  return res;
};

// get whatsapp templates
export const whatsappTemplates = async () => {
  const url = process.env.REACT_APP_API_BASE_URL + `${urls.whatsappTemplates}`;
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error, "error");
    });
  return res;
};

export const whatsappParams = async (templateid) => {
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.whatsappParams}?templateid=${templateid}`;
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error, "error");
    });
  return res;
};

//send whatsapp message

export const sendWhatsappMessage = async (payload, userId) => {
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.whatsappMessage}?userId=${userId}`;
  const headers = getAuthHeaders();
  const res = await axios
    .post(url, payload, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error, "error");
    });
  return res;
};

// get SMS templates

export const smsTemplates = async () => {
  const url = process.env.REACT_APP_API_BASE_URL + `${urls.smsTemplates}`;
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error, "error");
    });
  return res;
};

export const smsParams = async (templateid) => {
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.smsParams}?templateid=${templateid}`;
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error, "error");
    });
  return res;
};

//send SMS message

export const sendSmsMessage = async (payload, userId) => {
  const url =
    process.env.REACT_APP_API_BASE_URL + `${urls.smsMessage}?userId=${userId}`;
  const headers = getAuthHeaders();
  const res = await axios
    .post(url, payload, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error, "error");
    });
  return res;
};

// get Email Templates

export const emailTemplates = async () => {
  const url = process.env.REACT_APP_API_BASE_URL + `${urls.emailTemplates}`;
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error, "error");
    });
  return res;
};

export const emailParams = async (templateid) => {
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.emailParams}?templateid=${templateid}`;
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error, "error");
    });
  return res;
};

//send Email

export const sendEmailMessage = async (payload, userId) => {
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.emailMessage}?userId=${userId}`;
  const headers = getAuthHeaders();
  const res = await axios
    .post(url, payload, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error, "error");
    });
  return res;
};

// multi edit fields

export const multiFieldEdit = async (payload, accessKey, secretKey) => {
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.multieditlead}?accesskey=${accessKey}&secretkey=${secretKey}`;
  const headers = getAuthHeaders();
  const res = await axios
    .post(url, payload, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error, "error");
    });
  return res;
};

export const dispositionData = async (payload) => {
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.dispositionPopupList}?phone=${payload.phoneNumber}&leadsid=${payload.leadId}`;
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error, "error");
    });
  return res;
};
export const QueryDocData = async (leadId) => {
  const url =
    process.env.REACT_APP_REPORTS_BASE_URL +
    `api/${urls.mediaquerydocs}?leadsid=${leadId}`;
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error, "error");
    });
  return res;
};

export const getEkycSecureUrl = async ({ agent, uniqueid }) => {
  try {
    const url = `${process.env.REACT_APP_API_BASE_URL}/ekyc/getSecureURL`;
    const response = await axios.post(
      url,
      { agent, uniqueid },
      { headers: { "Content-Type": "application/json" } },
    );

    return response?.data ?? null;
  } catch (exception) {
    return exception?.response?.data ?? null;
  }
};

export const getLeadsByGlobalSearch = async (searchQuery) => {
  try {
    const headers = getAuthHeaders();

    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}globalSearchLeads`,
      {
        params: {
          searchQuery,
        },
        headers,
      }
    );

    return response?.data;
  } catch (error) {
    return error?.response?.data ?? null;
  }
};